import React from 'react'
import cn from 'classnames'
import Avatar from 'react-avatar'
import emojiRegex from 'emoji-regex'
import ReactTooltip from 'react-tooltip'

const Name = ({ firstName, lastName, email, showOnlyFirstName }) =>
  showOnlyFirstName && firstName
    ? firstName
    : firstName && lastName
    ? `${firstName != null ? firstName : ''} ${
        lastName != null ? lastName : ''
      }`
    : email || ''

export const Intials = (name = '', props) => {
  const regex = emojiRegex()
  const match = regex.exec(name)
  if (match && match.length) {
    return match[0]
  } else {
    return name.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g)
  }
}

export const YourLabel = ({ classNames, avatarId, isWebpSupported }) => {
  const webpSupported = isWebpSupported

  const imgSrc =
    avatarId && webpSupported !== undefined
      ? `${process.env.REACT_APP_IMAGE_LAMBDA}/profiles/${avatarId}.${
          webpSupported ? 'webp' : 'jpg'
        }?height=100&width=100`
      : ''

  return (
    <div className="circleContainer">
      <div className="labelOuter">
        {imgSrc ? (
          <img
            alt=""
            className={cn({
              ...classNames,
              'youCircle-profile-img': imgSrc,
            })}
            src={imgSrc}
          />
        ) : (
          <div className={cn(classNames)}>You</div>
        )}
      </div>
      <div
        className={cn({
          creditsProgressBarLong: true,
          leftRadius: true,
          creditsProgressBarColor: classNames.youLabelColored,
        })}
      />
    </div>
  )
}
// shows the user initials and first and last name
const FriendLabel = ({
  firstName = '',
  lastName = '',
  email,
  avatarId,
  size = 'small',
  showName = true,
  showEmail = true,
  showOnlyFirstName,
  friendLabelClasses,
  classNames,
  isWebpSupported,
  ...rest
}) => {
  const webpSupported = isWebpSupported

  const imgSrc =
    avatarId && webpSupported !== undefined
      ? `${process.env.REACT_APP_IMAGE_LAMBDA}/profiles/${avatarId}.${
          webpSupported ? 'webp' : 'jpg'
        }?height=100&width=100`
      : ''

  return (
    <div className={cn(friendLabelClasses, 'friendsLabel')} {...rest}>
      <div
        data-for={`friend-info-${
          firstName && lastName ? `${firstName} ${lastName}` : `${email}`
        }`}
        data-tip={
          firstName && lastName ? `${firstName} ${lastName}` : `${email}`
        }
      >
        <ReactTooltip
          className="foodsby-tooltip"
          delayHide={0}
          delayShow={500}
          delayUpdate={0}
          effect="float"
          id={`friend-info-${
            firstName && lastName ? `${firstName} ${lastName}` : `${email}`
          }`}
          offset={{ top: 10, right: 0 }}
          place="bottom"
        />
        <Avatar
          className={cn(classNames)}
          color="#d3d3d3"
          initials={Intials}
          name={firstName && lastName ? `${firstName} ${lastName}` : '@'}
          round
          size={size === 'small' ? 40 : size === 'medium' ? 60 : 80}
          src={imgSrc}
          style={{ color: 'white' }}
          textSizeRatio={2}
        />
      </div>
      {(showName || showEmail) && (
        <div className="friendDetails">
          <div>
            {showName && (
              <Name
                {...{
                  firstName,
                  lastName,
                  email,
                  showOnlyFirstName,
                }}
              />
            )}
            {showEmail && <div className="friendEmail">{email}</div>}
          </div>
        </div>
      )}
    </div>
  )
}

export default FriendLabel
